window.$ = window.jQuery = require('jquery');
require('./web_function')

require('./jquery_color')

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'
import {Draggable} from 'gsap/Draggable'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Draggable = Draggable;

import Swiper, { Navigation, Autoplay, Thumbs } from 'swiper'
window.Swiper = Swiper;
window.Navigation = Navigation;
window.Autoplay = Autoplay;
window.Thumbs = Thumbs;

import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_zh_TW';
require('./validation_helper');

import fullpage from 'fullpage.js/dist/fullpage.extensions.min';
window.fullpage = fullpage;

import Parallax from 'parallax-js'
window.Parallax = Parallax;

const lottie = require('./lottie')
window.lottie = lottie;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});